var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24778 0.500003L4.25 0.5H14.375L14.3771 0.500003C15.2709 0.502546 16.1273 0.858716 16.7593 1.4907C17.3913 2.12268 17.7475 2.97911 17.75 3.87287C17.75 3.87879 17.75 3.8847 17.7498 3.89062L17.7423 4.25H18.0781C19.968 4.25 21.5 5.78203 21.5 7.67188V18.0781C21.5 19.968 19.968 21.5 18.0781 21.5H7.67188C5.78203 21.5 4.25 19.968 4.25 18.0781V17.75H3.875L3.87287 17.75C2.97911 17.7475 2.12268 17.3913 1.4907 16.7593C0.858716 16.1273 0.502546 15.2709 0.500003 14.3771L0.5 14.375V4.25L0.500003 4.24778C0.502938 3.25471 0.898735 2.30315 1.60094 1.60094C2.30315 0.898735 3.25471 0.502938 4.24778 0.500003ZM5.75 18.0781C5.75 19.1395 6.61045 20 7.67188 20H18.0781C19.1395 20 20 19.1395 20 18.0781V7.67188C20 6.61045 19.1395 5.75 18.0781 5.75H16.9791C16.9776 5.75 16.9761 5.75 16.9746 5.75H7.67188C6.61045 5.75 5.75 6.61045 5.75 7.67188V18.0781ZM16.242 4.25H7.67188C5.78203 4.25 4.25 5.78203 4.25 7.67188V16.25H3.87621C3.37913 16.2483 2.90287 16.0501 2.55136 15.6986C2.19987 15.3471 2.00167 14.8709 2 14.3738V4.25119C2.00203 3.65478 2.23986 3.08335 2.66161 2.66161C3.08335 2.23986 3.65478 2.00203 4.25119 2H14.3738C14.8709 2.00167 15.3471 2.19987 15.6986 2.55136C16.0484 2.90117 16.2464 3.37454 16.25 3.86902L16.242 4.25Z",
    fill: "#006DB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f6174d3732f439260c62cdf192b6b478.svg";
export { ForwardRef as ReactComponent };